<template>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" @click="$router.push('/develop')" style="cursor: pointer">Developers</li>
          <li class="breadcrumb-item active" aria-current="page">Reporte archivos S3</li>
        </ol>
      </nav>
      <div class="container-fluid">
        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <vx-card>
              <h1 class="bold big-title m-0">Archivos almacenados en <span>buckets s3</span>.</h1>
            </vx-card>
          </div>
          <div class="vx-col w-full">
            <vx-card>
              <p>
                Consulta el estado de los archivos gestionados por el módulo <strong>DocumentManager</strong> utilizado en los forms dentro de las solicitudes de la 
                plataforma.
              </p>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <!-- FILTROS -->
                  <div>
                    <p class="bold black">Fechas a consultar</p>
                    <div class="row">
                      <div class="col-md-5 col-sm-12">
                        <label for="start">Inicio</label>
                        <datepicker class="w-full" name="start" v-model.lazy="rg_start" description="Fecha Inicio"
                          :language="es" :use-utc="true" format="yyyy-MM-dd" />
                      </div>
                      <div class="col-md-5 col-sm-12">
                        <label for="end">Fin</label>
                        <datepicker class="w-full" description="Fecha Fin" name="end" v-model.lazy="rg_end" :language="es"
                          :use-utc="true" format="yyyy-MM-dd" />
                      </div>
                      <div class="col-md-2 col-sm-12" style="padding-top: 1.8rem;">
                        <vs-button @click="downloadTxt()" color="warning" type="filled" icon-pack="feather"
                          icon="icon-download"></vs-button>
                      </div>
                    </div>
  
                  </div>
                  <!--  -->
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <vx-card></vx-card>
      </div>
    </div>
  </template>
    
  <script>
  import Datepicker from "vuejs-datepicker";
  import { es } from "vuejs-datepicker/dist/locale";
  import moment from 'moment'
  export default {
    name: "DocumentManagerReport",
    components: {
      Datepicker,
    },
    data() {
      return {
        es: es
        , rg_start: "2020-11-01"
        , rg_end: "2020-11-30"
        , now: null
      }
    },
    async created() {
      let end = moment().locale("es").format('YYYY-MM-DD');
      let start = moment().subtract(1, "months").format('YYYY-MM-DD');
      let now = moment().locale("es").format('YYMMDD');
      this.now = now;
      this.rg_start = start;
      this.rg_end = end;
    },
    methods: {
      async downloadTxt() {
        try {
          // this.showLoading(true);
          let start = moment(this.rg_start).locale("es").format('YYYY-MM-DD');
          let end = moment(this.rg_end).locale("es").format('YYYY-MM-DD');
          const res = await axios.post(`/api/get/document-manager-report?start=${start}&end=${end}`);
          // COMPLEMENTA EL STREAM DE ARCHIVOS CON UN MAGÍA DEL DOM
          const fileURL = window.URL.createObjectURL(new Blob([res.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${this.now}_documents.csv`);
          document.body.appendChild(fileLink);
          fileLink.click();
          doc.value = "";
          // this.showLoading(false);
          this.saveSuccessNotif();
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
  </script>
    
  <style scoped></style>
    